import locales from './locales.json'

export default locales
